import React, { useState } from 'react';
import SecondaryConsentModal from './SecondaryConsentModal';
import { PRACTICE, SECONDARY_CONSENT_URL } from '@/data/conciergeCommon';

// §secondary-consent: Dr. Mavroson's Jotform consent. Mount it only once the
// patient has paid for one of his programs — it opens the pop-up immediately,
// and the button stays on the confirmation screen to reopen it.
const SecondaryConsentPrompt = ({ className = 'max-w-md mx-auto mb-5' }) => {
  const [open, setOpen] = useState(true);
  return (
    <>
      <div className={`rounded-2xl border border-amber-200 bg-amber-50 p-4 text-left ${className}`} data-testid="secondary-consent-cta">
        <p className="text-sm text-amber-900 mb-3">
          <span className="font-semibold">One more step:</span> please complete {PRACTICE.practitionerShort}'s consent form.
        </p>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="w-full rounded-xl bg-[#2d8a5f] text-white font-semibold py-2.5 hover:bg-[#256f4d] transition-colors"
          data-testid="secondary-consent-open"
        >
          Complete consent form
        </button>
      </div>
      <SecondaryConsentModal
        open={open}
        url={SECONDARY_CONSENT_URL}
        title={`${PRACTICE.practitionerShort} — consent form`}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default SecondaryConsentPrompt;
